export default "__VITE_ASSET__BUFdrKD4__"